import { useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { publicationdetail } from "../../../../services/publicationService";
import { buildPDFPath } from "../../../../utils/slugify";
import { AppContext } from "../../../../services/AuthContext";

export default function RedirectPDFOpenAccessById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await publicationdetail(id, auth?.token);
        if (!alive) return;
        if (res?.status === "OK") {
          const pub = res.data?.elasticjson || res.data;

          // Öncelikli olarak makale başlığı (publicationtypeInfo içinden)
          let title =
            pub?.publicationtypeInfo?.find(
              (a) => a.attributename?.toLowerCase() === "başlık"
            )?.value?.[0]?.value?.[0] ||
            // Eğer makale değilse dergi/sayı adı parentList'te olabilir:
            pub?.parentList?.[0]?.publicationtypeInfo?.find(
              (a) => a.attributename?.toLowerCase() === "başlık"
            )?.value?.[0]?.value?.[0] ||
            // Alternatif fallback:
            pub?.title ||
            pub?.name ||
            `Yayın-${id}`;

          navigate(buildPDFPath({ title, id }), { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } catch (e) {
        navigate("/home", { replace: true });
      }
    })();
    return () => {
      alive = false;
    };
  }, [id, navigate, auth]);

  return null;
}